<template>
  <div v-loading="pageLoading">
    <div>
      <h1>章節設置</h1>
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="章節名稱" class="gold_item_label">
          <el-input
            v-model="form.sectionName"
            placeholder="請輸入章節名稱"
            type="textarea"
            :rows="3"
            style="width: 300px"
            maxlength="100"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="章節簡介" class="gold_item_label">
          <el-input
            type="textarea"
            :rows="2"
            style="width: 600px"
            maxlength="500"
            show-word-limit
            v-model="form.intro"
            placeholder="請輸入章節簡介"
          ></el-input>
        </el-form-item>
        <el-form-item label="章節教材" prop="rul" v-if="courseType == 'online'">
          <!-- 圖片 -->
          <el-upload
            class="upload-demo"
            action=""
            accept=".jpg,.png,.gif"
            :on-remove="handleRemove1"
            :file-list="fileList1"
            :auto-upload="false"
            list-type="picture-card"
            :on-change="changeFile1"
            multiple
            v-if="fileList2.length == 0 && fileList3.length == 0"
          >
            <i class="el-icon-plus"></i>
            <div slot="tip" class="el-upload__tip" style="color: #ff0000">
              建議圖片尺寸：1130px (闊)
            </div>
          </el-upload>
          <!-- 分界线 -->
          <div style="margin: 20px 0"></div>
          <!-- 視頻 -->
          <el-upload
            class="upload-demo"
            action=""
            accept=".MP4,.AVI"
            :on-remove="handleRemove2"
            :file-list="fileList2"
            :auto-upload="false"
            list-type="text"
            :on-change="changeFile2"
            :limit="1"
            :on-exceed="exceed"
            v-if="fileList1.length == 0 && fileList3.length == 0"
          >
            <el-button slot="trigger" size="small" type="primary"
              >上傳視頻</el-button
            >
          </el-upload>
          <!-- 分界线 -->
          <div style="margin: 20px 0"></div>
          <!-- PDF -->
          <el-upload
            class="upload-demo"
            action=""
            accept=".pdf"
            :on-remove="handleRemove3"
            :file-list="fileList3"
            :auto-upload="false"
            :on-change="changeFile3"
            list-type="text"
            :limit="1"
            :on-exceed="exceed"
            v-if="fileList1.length == 0 && fileList2.length == 0"
          >
            <el-button size="small" type="primary">上傳PDF</el-button>
          </el-upload>

          <!-- 分界线 -->
          <div style="margin: 20px 0"></div>
        </el-form-item>

        <el-form-item label="直播時間" v-show="courseType == 'live'">
          <el-date-picker
            :picker-options="pickerOptions"
            format="yyyy-MM-dd HH:mm"
            value-format="yyyy-MM-dd HH:mm:ss"
            v-model="time"
            type="datetime"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="新增課程測驗">
          <el-button
            v-if="questionId == ''"
            @click="questionSet"
            style="font-size: 30px"
            icon="el-icon-plus"
          ></el-button>
          <span v-else>
            <span style="padding: 0 10px">{{ questionName }}</span>
            <el-button
              type="warning"
              icon="el-icon-edit"
              circle
              @click="editQuestion"
            ></el-button>
            <!-- <el-button type="danger" icon="el-icon-delete" circle @click="delQue"></el-button> -->
          </span>
        </el-form-item>
        <el-form-item label="新增課程意見">
          <el-button
            v-if="assessmentId == ''"
            @click="assessmentSet"
            style="font-size: 30px"
            icon="el-icon-plus"
          ></el-button>
          <span v-else>
            <span style="padding: 0 10px">{{ assessmentName }}</span>
            <el-button
              type="warning"
              icon="el-icon-edit"
              circle
              @click="editAssessment"
            ></el-button>
            <!-- <el-button type="danger" icon="el-icon-delete" circle @click="delAss"></el-button> -->
          </span>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">保存</el-button>
          <el-button @click="back">取消</el-button>
        </el-form-item>
      </el-form>
      <el-button class="btn" @click="back">返 回</el-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    var checkImg = (rule, value, callback) => {
      console.log("this.form.picture_file", this.form.picture_file);
      if (
        this.form.picture_file ||
        this.form.video_file ||
        this.form.content_file
      ) {
        callback();
      } else {
        callback(new Error("圖片、視頻或者PDF，至少上傳一樣"));
      }
    };
    return {
      pageLoading: false,

      pickerOptions: {
        // 時間限制
        disabledDate(time) {
          return time.getTime() <= Date.now() - 3600 * 1000 * 24;
        },
      },
      form: {
        sectionName: "",
        intro: "",
        picture_file: "",
        video_file: "",
        content_file: "",
      },
      rules: {
        rul: [{ validator: checkImg, trigger: "change" }],
      },
      fileList1: [],
      fileList2: [],
      fileList3: [],
      id: "",
      questionId: "",
      questionName: "",
      assessmentId: "",
      assessmentName: "",
      testingQualified: "",
      forcedAnswer: "",
      courseType: false,
      time: null,
    };
  },
  methods: {
    back() {
      sessionStorage.removeItem("questionMsg");
      sessionStorage.removeItem("assessmentMsg");
      this.$emit("back");
    },
    handleRemove1(file, fileList) {
      //文件刪除
      this.form.picture_file = "";
      this.fileList1 = fileList;
      this.$refs.form.validateField("rul");
    },
    handleRemove2(file, fileList) {
      //文件刪除
      this.form.video_file = "";
      this.fileList2 = fileList;
      this.$refs.form.validateField("rul");
    },
    handleRemove3(file, fileList) {
      //文件刪除
      this.form.content_file = "";
      this.fileList3 = fileList;
      this.$refs.form.validateField("rul");
    },
    changeFile1(file, fileList) {
      this.fileList1 = fileList;
      this.form.picture_file = this.fileList1;
      this.$refs.form.validateField("rul");
    },
    changeFile2(file, fileList) {
      this.fileList2 = fileList;
      this.form.video_file = this.fileList2;
      this.$refs.form.validateField("rul");
    },
    changeFile3(file, fileList) {
      this.fileList3 = fileList;
      this.form.content_file = this.fileList3;
      this.$refs.form.validateField("rul");
    },
    exceed() {
      this.$message({
        type: "warning",
        message: "該類型只能上傳一個!",
      });
    },
    onSubmit() {
      var that = this,
        form = this.form;
      let formData = new FormData();
      let msg = {};
      if (form.sectionName == "") {
        this.$message({
          type: "warning",
          message: "請新增章節名稱",
        });
        return;
      }
      msg["sectionName"] = form.sectionName;
      formData.append("sectionName", form.sectionName);
      if (form.intro == "") {
        this.$message({
          type: "warning",
          message: "請新增章節簡介",
        });
        return;
      }
      msg["intro"] = form.intro;
      formData.append("intro", form.intro);
      formData.append("state", 1);
      msg["state"] = 1;

      msg["id"] = this.id;

      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.courseType == "online") {
            // 線上
            let fileList1 = this.fileList1;
            let fileList2 = this.fileList2;
            let fileList3 = this.fileList3;
            if (fileList1.length > 0) {
              let arr = [];
              for (let i = 0; i < fileList1.length; i++) {
                if (fileList1[i].raw) {
                  formData.append("file", fileList1[i].raw);
                } else {
                  arr.push(fileList1[i].url);
                }
              }
              if (arr.length > 0) {
                formData.append("pictureFileUrl", "[" + arr.toString() + "]");
              }
            }
            if (fileList2.length > 0) {
              if (fileList2[0].raw) {
                formData.append("file", fileList2[0].raw);
              } else {
                formData.append("videoFileUrl", "[" + fileList2[0].url + "]");
              }
            }
            if (fileList3.length > 0) {
              if (fileList3[0].raw) {
                formData.append("file", fileList3[0].raw);
              } else {
                formData.append("contentFileUrl", "[" + fileList3[0].url + "]");
              }
            }
            formData.append("id", this.id);
            formData.append(
              "manOnlineCoursesId",
              sessionStorage.getItem("courseId")
            );
            formData.append(
              "manOnlineUeviomsIds",
              "[" + this.assessmentId + "]"
            );
            formData.append("manOnlineTestingIds", "[" + this.questionId + "]");
            console.log("form", form);
            // return
            this.pageLoading = true
            this.axios
              .post("/manage/updateManOnlineSection", formData, {
                headers: {
                  "content-type": "multipart/form-data",
                },
              })
              .then(res => {
                if (res) {
                  that.$message({
                    type: "success",
                    message: "修改成功!",
                  });
                  sessionStorage.removeItem("questionMsg");
                  sessionStorage.removeItem("assessmentMsg");
                  setTimeout(function () {
                    that.back()
                    //that.$router.go(-1);
                  }, 1000);
                } else {
                  this.pageLoading = false
                }
              }).catch(() => {
                this.pageLoading = false
              })
          } else if (this.courseType == "offline") {
            // 綫下
            formData.append("id", this.id);
            formData.append(
              "manOfflineCoursesId",
              sessionStorage.getItem("courseId")
            );
            formData.append(
              "manOfflineUeviomsIds",
              "[" + this.assessmentId + "]"
            );
            formData.append(
              "manOfflineTestingIds",
              "[" + this.questionId + "]"
            );
            // msg["manOfflineCoursesId"] = sessionStorage.getItem("courseId");
            // msg["manOfflineTestingIds"] = "[" + this.questionId + "]";
            // msg["manOfflineUeviomsIds"] = "[" + this.assessmentId + "]";
            this.pageLoading = true
            this.axios
              .post("/manage/updateManOfflineSection", formData, {
                headers: {
                  "content-type": "multipart/form-data",
                },
              })
              .then((res) => {
                if (res) {
                  this.$message({
                    type: "success",
                    message: "修改成功!",
                  });
                  sessionStorage.removeItem("questionMsg");
                  sessionStorage.removeItem("assessmentMsg");
                  setTimeout(()=> {
                    that.back()
                    //that.$router.go(-1);
                  }, 1000);
                } else {
                  this.pageLoading = false
                }
              }).catch(() => {
                this.pageLoading = false
              })
          } else if (this.courseType == "live") {
            msg["manLiveCoursesId"] = sessionStorage.getItem("courseId");
            msg["liveTime"] = this.time;
            this.pageLoading = true
            this.axios({
              method: "post",
              params: msg,
              url: "/manage/updateManLiveSection",
            }).then((res) => {
              if (res) {
                this.$message({
                  type: "success",
                  message: "修改成功!",
                });
                sessionStorage.removeItem("questionMsg");
                sessionStorage.removeItem("assessmentMsg");
                setTimeout(()=> {
                  that.back()
                  //that.$router.go(-1);
                }, 1000);
              } else {
                this.pageLoading = false
              }
            }).catch(() => {
              this.pageLoading = false
            })
          }
        } else {
          this.$message({
            type: "warning",
            message: "必須選擇上傳圖片、視頻或文件其中一項為此章節教材!",
          });
          console.log("error submit!!");
          return false;
        }
      });
    },
    questionSet() {
      sessionStorage.removeItem("questionSet");
      this.$emit("add-page", "question");
    },
    assessmentSet() {
      sessionStorage.removeItem("assessmentSet");
      this.$emit("add-page", "assessment");
    },
    editQuestion() {
      sessionStorage.questionSet = JSON.stringify({
        id: this.questionId,
        qualified: this.testingQualified,
        name: this.questionName,
        sessionId: this.id,
        forcedAnswer: this.forcedAnswer,
      });
      this.$emit("add-page", "ediTquestionSet");
    },
    editAssessment() {
      sessionStorage.assessmentSet = JSON.stringify({
        id: this.assessmentId,
        name: this.assessmentName,
        sessionId: this.id
      });
      this.$emit("add-page", "editAssessmentSet");
    },
    delQue() {
      this.$confirm("確認刪除？", "提示", {
        confirmButtonText: "確定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          sessionStorage.removeItem("editQuestionMsg");
          this.questionId = "";
          this.questionName = "";
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    delAss() {
      this.$confirm("確認刪除？", "提示", {
        confirmButtonText: "確定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          sessionStorage.removeItem("editAssessmentMsg");
          this.assessmentId = "";
          this.assessmentName = "";
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    changePage() {
      $("#pageHead").text("修改章節");
      //var questionMsg = sessionStorage.getItem("questionSet");
      var questionMsg = sessionStorage.getItem("questionMsg");
      var assessmentMsg = sessionStorage.getItem("assessmentMsg");

     // console.log("questionMsg"+questionMsg+"*********************"+"assessmentMsg"+assessmentMsg)

      if (questionMsg) {
        let msg = JSON.parse(questionMsg);
        this.questionId = msg.id
        this.questionName = msg.name
      }
      if (assessmentMsg) {
        let msg = JSON.parse(assessmentMsg);
        this.assessmentId = msg.id
        this.assessmentName = msg.name
      }
    },
  },
  created() {
    let type = sessionStorage.getItem("courseType");
    this.courseType = type;
    var msg = JSON.parse(sessionStorage.getItem("editSectionMsg"));
    var form = this.form;
    form.sectionName = msg.sectionName;
    form.intro = msg.intro;
    form.picture_file = msg.pictureFile;
    form.video_file = msg.videoFile;
    form.content_file = msg.contentFile;
    this.id = msg.id;
    if (msg.tuList.length > 0) {
      var tuList = msg.tuList[0];
      if (tuList.testingQualified) {
        this.testingQualified = tuList.testingQualified;
      }
      if (tuList.testingForcedAnswer) {
        this.forcedAnswer = tuList.testingForcedAnswer;
      }
    }
    this.fileList1 = [];
    this.fileList2 = [];
    this.fileList3 = [];
    if (type == "online") {
      this.pageLoading = true
      this.axios
        .get("/manage/getOnTestingAndUeviomsName?id=" + msg.id)
        .then((res) => {
          let result = res.result;
          if (result) {
            if (result.testingId) {
              this.questionId = result.testingId;
              this.questionName = result.testingName;
            }
            if (result.ueviomsId) {
              this.assessmentId = result.ueviomsId;
              this.assessmentName = result.ueviomsName;
            }
          }
          this.pageLoading = false
        }).catch(() => {
          this.pageLoading = false
        })
      var pic = msg.pictureFile.split(",");
      for (var i = 0; i < pic.length; i++) {
        if (pic[i] != "") {
          this.fileList1.push({
            url: pic[i],
          });
        }
      }
      if (msg.videoFile != "") {
        this.fileList2.push({
          name: msg.fileName,
          url: msg.videoFile,
        });
      }
      if (msg.contentFile != "") {
        this.fileList3.push({
          name: msg.fileName,
          url: msg.contentFile,
        });
      }
    } else if (type == "offline") {
      this.pageLoading = true
      this.axios
        .get("/manage/getTestingAndUeviomsName?id=" + msg.id)
        .then((res) => {
          let result = res.result;
          if (result) {
            if (result.testingId) {
              this.questionId = result.testingId;
              this.questionName = result.testingName;
            }
            if (result.ueviomsId) {
              this.assessmentId = result.ueviomsId;
              this.assessmentName = result.ueviomsName;
            }
          }
          this.pageLoading = false
        }).catch(() => {
          this.pageLoading = false
        })
      var pic2 = msg.pictureFile.split(",");
      for (var j = 0; j < pic2.length; j++) {
        if (pic2[j] != "") {
          this.fileList1.push({
            url: pic2[j],
          });
        }
      }
      if (msg.videoFile != "") {
        this.fileList2.push({
          name: msg.fileName,
          url: msg.videoFile,
        });
      }
      if (msg.contentFile != "") {
        this.fileList3.push({
          name: msg.fileName,
          url: msg.contentFile,
        });
      }
    } else if (type == "live") {
      this.time = msg.liveTime;
      this.pageLoading = true
      this.axios
        .get("/manage/getLiveTestingAndUeviomsName?id=" + msg.id)
        .then((res) => {
          let result = res.result;
          if (result) {
            if (result.testingId) {
              this.questionId = result.testingId;
              this.questionName = result.testingName;
            }
            if (result.ueviomsId) {
              this.assessmentId = result.ueviomsId;
              this.assessmentName = result.ueviomsName;
            }
          }
          this.pageLoading = false
        }).catch(() => {
          this.pageLoading = false
        })
    }
  },
  mounted() {
    this.changePage();
  },
};
</script>

<style scoped>
.btn {
  position: absolute;
  top: 90px;
  right: 45px;
}
.el-upload__tip {
  color: #ff0000;
}
</style>
